import { Button, Dialog, DialogTitle } from "@mui/material";

import { ModalHeadWrapper } from "@/components/molecules/Modal/styles";

import { AddUserForm } from "../AddUserForm";

interface AddUserPopupProps {
  trigger: boolean;
  setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AddUserPopup = (props: AddUserPopupProps) => {
  return (
    <Dialog open={props.trigger} onClose={() => props.setTrigger(false)}>
      <ModalHeadWrapper>
        <DialogTitle>Create New Account</DialogTitle>
        <Button className="button" onClick={() => props.setTrigger(false)}>
          X
        </Button>
      </ModalHeadWrapper>
      <AddUserForm />
    </Dialog>
  );
};
